import {Text} from '@dropbox/dig-components/typography';
import type {ReactNode} from 'react';
import styles from 'views/roadmap/Roadmap.module.css';
import type {RoadmapViewMode} from 'views/roadmap/types';

interface RoadmapTabProps {
  progressStrip?: ReactNode;
  toolbar: ReactNode;
  toolbarLeading?: ReactNode;
  hasResults: boolean;
  viewMode: RoadmapViewMode;
  tableContent: ReactNode;
  ganttContent: ReactNode;
}

export const RoadmapTab = ({
  progressStrip,
  toolbar,
  toolbarLeading,
  hasResults,
  viewMode,
  tableContent,
  ganttContent,
}: RoadmapTabProps) => (
  <section className={styles.section}>
    {progressStrip ? <div>{progressStrip}</div> : null}
    <div className={styles.roadmapToolbar}>
      {toolbarLeading ? <div className={styles.roadmapToolbarLeading}>{toolbarLeading}</div> : null}
      <div className={styles.roadmapToolbarFilters}>{toolbar}</div>
    </div>

    {viewMode === 'table' ? (
      <div
        className={styles.stickyTableViewport}
        role="region"
        aria-label="Roadmap initiatives table"
        tabIndex={0}
      >
        {tableContent}
      </div>
    ) : !hasResults ? (
      <div className={styles.emptyState}>
        <Text color="subtle">No initiatives matched the current roadmap filters.</Text>
      </div>
    ) : (
      ganttContent
    )}
  </section>
);
